import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const TextRankList = styled.ol`
  ${mixin.flex({
    direction: 'column',
    wrap: 'wrap',
    justify: 'flex-start',
    align: 'flex-start',
  })}

  margin-top: 14px;
  max-height: 160px;

  .item {
    width: 50%;
    padding-right: 4px;

    &:nth-child(n + 6) {
      padding-right: 0;
      padding-left: 4px;
    }

    &:nth-child(-n + 3) .word {
      color: #262626;
      font-weight: 500;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('14')};
    max-height: ${mixin.pxToVw('160')};

    .item {
      padding-right: ${mixin.pxToVw('4')};

      &:nth-child(n + 6) {
        padding-left: ${mixin.pxToVw('4')};
      }
    }
  }
`;
